import React from "react"
import styled from "styled-components"

import PageHeader from "../PageHeader"
import config from "../../Config"
import Cookie from "../../util/Cookie"
import { event } from "../../components/reactGA"
import { I18nContext } from "react-i18next"
import i18n from "../../i18n"

const Container = styled.div`
  height: 100%;
  overflow: hidden;
`

const Body = styled.div`
  height: calc(100% - 45px);
  overflow-y: scroll;
`

const InviteBox = styled.div`
  height: inherit;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  padding: 20px;
`

const SocialShare = styled.div`
  display: flex;
  justify-content: space-around;
  margin: 10px 0px;
`

const SocialIcon = styled.div`
  margin-left: 20px;
  margin-right: 20px;
  display: flex;
`

class InviteAndEarn extends React.Component {
  constructor(props) {
    super(props)
    const userId = Cookie.get("X-U2Web-ReferralCode")
    const link = `${config.BILLING_URL}/?referrerReferCode=${userId}`
    let shareTxt = i18n.t("ReferalTextMsg")
    this.state = {
      shareText: `${shareTxt} ${link}`,
    }
    this.onWhatsappPress = this.onWhatsappPress.bind(this)
    this.onMessengerPress = this.onMessengerPress.bind(this)
  }

  onWhatsappPress() {
    window.open(
      `whatsapp://send?text=${window.encodeURIComponent(this.state.shareText)}`
    )
    event({
      category: "Invite & Earn Page",
      action: "Whatsapp Invite",
    })
  }

  onMessengerPress() {
    window.open(
      `fb-messenger://share?link=${encodeURIComponent(
        this.state.shareText
      )}&app_id=encodeURIComponent(${config.FACEBOOK_APPID}`
    )
    event({
      category: "Invite & Earn Page",
      action: "Fb Messenger Invite",
    })
  }

  componentWillMount() {
    const locale = Cookie.get("X-Reycreo-Language-Id")
    i18n.changeLanguage(locale || "en")
    console.log("RENDER Invite And Earn :: ", locale)
  }

  render() {
    return (
      <Container>
        <PageHeader label={i18n.t("UnlimitedFreeBids")} backLocation='/play/' />
        <Body>
          <InviteBox>
            <img
              src={`http://di7iff3954bd3.cloudfront.net/mrbidnwin/images/ic-invite-friends.svg`}
              alt='invite-friends'
            />
            <span className='text-center montserratLight'>
              {i18n.t("FreeBidsOnRegister")}
            </span>
            <SocialShare>
              <SocialIcon>
                <img
                  onClick={this.onWhatsappPress}
                  width='55px'
                  height='55px'
                  src={`${config.BIDNWIN_S3_IMAGE_URL}/whatsapp.png`}
                  alt='Whatsapp-share'
                />
              </SocialIcon>
              <SocialIcon>
                <img
                  onClick={this.onMessengerPress}
                  width='55px'
                  height='55px'
                  src={`${config.BIDNWIN_S3_IMAGE_URL}/messenger.png`}
                  alt='Facebook-share'
                />
              </SocialIcon>
            </SocialShare>
          </InviteBox>
        </Body>
      </Container>
    )
  }
}

export default InviteAndEarn



// WEBPACK FOOTER //
// ./src/views/InviteAndEarn/index.js